import { call, put, takeEvery } from "redux-saga/effects";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { GET_COUNTRYCODE, GET_LOGIN, GET_OTP, POST_LOGOUT } from "resources/actionTypes";
import { countryCodeApi, loginApi, logoutApi, otpApi } from "services/AuthService";
import store from "redux/store";
import { getProfile } from "redux/actions/ProfileAction";
import { onLoaderTrigger } from "redux/actions/commonAction";

function* fetchLogin(action) {
  const payload = action.payload || {};
  const userLogin = yield call(loginApi, payload.userLogin);
  if (userLogin.success) {
    yield put({ type: GET_LOGIN.GET_LOGIN_SUCCESS, userLogin: userLogin });
    localStorage.setItem("mobile", payload.userLogin.mobileOrEmail);
    localStorage.setItem("code", payload.userLogin.countryCode);
    localStorage.setItem("secretToken", userLogin.data[0].otpSecret);
    toast.success(userLogin.message);
  } else {
    yield put({ type: GET_LOGIN.GET_LOGIN_FAILED, message: userLogin.message });
    if (userLogin.message) {
      toast.error(userLogin.message);
    } else {
      toast.error("Login failed");
    }
  }
}

export function* loginSaga() {
  yield takeEvery(GET_LOGIN.GET_LOGIN_REQUESTED, fetchLogin);
}

function* fetchOtp(action) {
  const payload = action.payload || {};
  const userOtp = yield call(otpApi, payload.userOtp);
  if (userOtp.success) {
    localStorage.setItem("token", userOtp?.data[0]?.token);
    yield put({ type: GET_OTP.GET_OTP_SUCCESS, userOtp: userOtp });
    toast.success(userOtp.message);
    store.dispatch(getProfile("auth"));
  } else {
    yield put({ type: GET_OTP.GET_OTP_FAILED, message: userOtp.message });
    if (userOtp.message) {
      toast.error(userOtp.message);
    } else {
      toast.error("Otp failed");
    }
  }
}

export function* otpSaga() {
  yield takeEvery(GET_OTP.GET_OTP_REQUESTED, fetchOtp);
}

function* logoutListener() {
  store.dispatch(onLoaderTrigger(true));
  const userLogout = yield call(logoutApi);
  if (userLogout.success) {
    localStorage.clear();
    window.location.replace('/login');
    yield put({ type: POST_LOGOUT.POST_LOGOUT_SUCCESS, userLogout: userLogout });
  } else {
    yield put({ type: POST_LOGOUT.POST_LOGOUT_FAILED, message: userLogout.message });
      toast.error(userLogout.message || "Logout Failed");
  }
  store.dispatch(onLoaderTrigger(false));
}

export function* logoutSaga() {
  yield takeEvery(POST_LOGOUT.POST_LOGOUT_REQUESTED, logoutListener);
}

function* getCountryCodeWorker() {
  store.dispatch(onLoaderTrigger(true));
  const countryCodeResponse = yield call(countryCodeApi);
  if (countryCodeResponse.success) {
    yield put({ type: GET_COUNTRYCODE.GET_COUNTRYCODE_SUCCESS, countryCodeList: countryCodeResponse });
  } else {
    yield put({ type: GET_COUNTRYCODE.GET_COUNTRYCODE_FAILED, message: countryCodeResponse.message });
      toast.error(countryCodeResponse.message || "Country code Fetching Failed");
  }
  store.dispatch(onLoaderTrigger(false));
}

export function* getCountryCodeWathcer() {
  yield takeEvery(GET_COUNTRYCODE.GET_COUNTRYCODE_REQUESTED, getCountryCodeWorker);
}